import { formatTRY } from '../../utils/money'
import { MEAL_CARDS, type MealCard } from '../../types'

/**
 * Markaların kendi sitelerinden alınan simgeleri (21 Eki 2026), public/brand/meal.
 * Uygulamanın içinde: başka sunucudan çekilmiyor, yavaş internette de görünür.
 */
const MEAL_LOGOS: Record<MealCard, string> = {
  Ticket: '/brand/meal/ticket.png',
  Sodexo: '/brand/meal/sodexo.png',
  Multinet: '/brand/meal/multinet.png',
  Setcard: '/brand/meal/setcard.png',
  Metropol: '/brand/meal/metropol.svg',
  Tokenflex: '/brand/meal/tokenflex.png',
}

interface Props {
  totalKurus: number
  onPick: (card: MealCard) => void
  onCancel: () => void
}

/**
 * Yemek kartı markası (21 Eki 2026). Ödeme düğmelerinin altında açılıyor,
 * TenderPicker ve BahsisPanel gibi: hangi kartla ödendiği raporda ayrı
 * görünsün, şirketten gelen ödemeyle karşılaştırılabilsin.
 */
export function MealCardPicker({ totalKurus, onPick, onCancel }: Props) {
  return (
    <div className="tender mealpick" role="group" aria-label="Yemek kartı">
      <div className="tender__head">
        <span className="tender__q">Hangi yemek kartı?</span>
        <span className="tender__amount">{formatTRY(totalKurus)}</span>
      </div>
      <div className="mealpick__grid">
        {MEAL_CARDS.map((c) => (
          <button key={c} type="button" className="mealpick__opt" onClick={() => onPick(c)}>
            <img src={MEAL_LOGOS[c]} alt="" className="mealpick__logo" />
            {c}
          </button>
        ))}
      </div>
      <button type="button" className="bahsis__cancel" onClick={onCancel}>
        Vazgeç
      </button>
    </div>
  )
}
